import { useEffect } from 'react';

interface HelmetProps {
  title?: string;
  children?: React.ReactNode;
}

export default function Helmet({ title, children }: HelmetProps) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  useEffect(() => {
    if (!children) return;

    const container = document.createDocumentFragment();
    const temp = document.createElement('div');
    temp.innerHTML = typeof children === 'string' ? children : '';

    const fragment = document.createDocumentFragment();
    while (temp.firstChild) {
      fragment.appendChild(temp.firstChild);
    }

    const head = document.head;
    const appended: Node[] = [];
    fragment.childNodes.forEach((node) => {
      head.appendChild(node);
      appended.push(node);
    });

    return () => {
      appended.forEach((node) => {
        if (node.parentNode) {
          node.parentNode.removeChild(node);
        }
      });
    };
  }, [children]);

  return null;
}